<template>
  <basic-container>
    <el-dialog
      :title="title"
      :visible.sync="openFlag"
      :modal-append-to-body="false"
      width="64%"
      @closed="handleClose"
      append-to-body
    >
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :permission="permissionList"
        v-model="form"
        ref="crud"
        @on-load="onLoad"
        @refresh-change="onLoad"
      >
        <template slot="complaintStatus" slot-scope="scope">
          <el-tag v-show="scope.row.complaintStatus == 1">登记</el-tag>
          <el-tag v-show="scope.row.complaintStatus == 2">受理</el-tag>
          <el-tag type="success" v-show="scope.row.complaintStatus == 3">处理</el-tag>
          <el-tag type="success" v-show="scope.row.complaintStatus == 4">回访</el-tag>
          <el-tag type="warning" v-show="scope.row.complaintStatus == 5">完成</el-tag>
        </template>
      </avue-crud>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/repairlog/repairlog';
import { mapGetters } from 'vuex';
import { getDictionary } from '@/api/common';

export default {
  data() {
    return {
      title: '',
      allComplaintStatusList: {},
      openFlag: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        menu: false,
        indexLabel: '序号',
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '操作人',
            prop: 'createName',
          },
          {
            label: '操作时间',
            prop: 'createTime',
          },
          {
            label: '状态',
            prop: 'complaintStatus',
            slot: true,
          },
          {
            label: '工单处理部门',
            prop: 'deptName',
          },
          {
            label: '工单责任人',
            prop: 'userName',
          },
          {
            label: '操作描述',
            prop: 'content',
          },
          {
            label: '备注',
            prop: 'remark',
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.repairlog_add, false),
        viewBtn: this.vaildData(this.permission.repairlog_view, false),
        delBtn: this.vaildData(this.permission.repairlog_delete, false),
        editBtn: this.vaildData(this.permission.repairlog_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
        }
      );
    },
    handleClose() {
      this.data = [];
      this.query = {};
      this.page = {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      };
      this.allComplaintStatusList = {};
    },
    openRepairLogDialog(id, title) {
      console.log(title);
      this.title = '工单 ' + title + ' 历程';
      this.query.repairId = id;
      this.onLoad();
      this.initSelectList();
      this.openFlag = true;
    },
    initSelectList() {
      getDictionary('complaint_status').then((data) => {
        this.allComplaintStatusList = data.data;
      });
    },
  },
};
</script>

<style scoped></style>
